// ─── Public Status Page — "this is the last saved copy" ──────────────
//
// Shown ONLY while the page is rendering the static snapshot because the live
// API could not be reached. It must never be mistaken for an outage banner:
// the figures below it may be perfectly fine, they are simply older than they
// look. So it is a warning-toned NOTICE with its own heading, not a status
// colour — the status colour on this page always means "this is what the
// services are doing", and nothing else.
//
// `failures > 0` means even the snapshot request failed just now, i.e. the
// visitor is very likely offline: say so, because "retry" is useless advice to
// someone whose wifi dropped.

import { da } from '../i18n/da';
import { fmtDateTime } from '../lib/format';
import type { DegradedNoticeProps } from '../types';
import { SIcon } from '../ui/SIcon';

export function DegradedNotice({ generatedAt, fetchedAt, failures, onRetry }: DegradedNoticeProps) {
  const offline = failures > 0;

  return (
    <div className="sp-notice" role="status" aria-live="polite">
      <SIcon name="degraded" size={20} className="sp-notice-icon" />
      <div className="sp-notice-body">
        <p className="sp-notice-title">{da.degradedTitle}</p>
        <p className="sp-notice-text">{da.degradedBody}</p>
        {offline && <p className="sp-notice-text">{da.degradedOffline}</p>}
        <p className="sp-notice-text">
          {da.degradedAt(fmtDateTime(generatedAt))}
          {fetchedAt !== null ? ` · ${da.lastChecked(fmtDateTime(fetchedAt))}` : ''}
        </p>
        <div className="sp-notice-actions">
          <button type="button" className="sp-btn sp-btn--sm" onClick={onRetry}>
            {da.retry}
          </button>
        </div>
      </div>
    </div>
  );
}
